export default "__VITE_ASSET__BYzjjw3m__"